import ICEEval from './ICEEval/ICEEval';
import './App.css';
import Layout from './Layout/Layout';

function App() {
  return (
    <div className="App">
      <Layout>
        <ICEEval />
      </Layout>
    </div>
  );
}

export default App;
